import { render, staticRenderFns } from "./SelectBrand.vue?vue&type=template&id=d31e0b9c&scoped=true"
import script from "./SelectBrand.vue?vue&type=script&lang=js"
export * from "./SelectBrand.vue?vue&type=script&lang=js"
import style0 from "./SelectBrand.vue?vue&type=style&index=0&id=d31e0b9c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d31e0b9c",
  null
  
)

export default component.exports